"use client";

import Image from "next/image";
import Link from "next/link";
import { useTranslations } from "next-intl";

import andreiImg from "@/app/assets/illustration/Sleep problems/Andrei.xs.webp";
import tamaraImg from "@/app/assets/illustration/Sleep problems/Tamara.xs.webp";

export function SolutionBridgeSection() {
    const t = useTranslations("Problems");

    return (
        <section className="">
            <div className="container mx-auto px-4">
                <div className="max-w-3xl mx-auto text-center">
                    <h2 className="text-3xl md:text-4xl font-bold mb-6 text-black">{t("bridge.title")}</h2>
                    <p className="text-lg mb-8 text-gray-700">{t("bridge.description")}</p>

                    {/* Founder Images */}
                    <div className="flex justify-center gap-8 mb-10">
                        <div className="text-center">
                            <div className="relative w-16 h-16 mb-10 mx-auto overflow-hidden">
                                <Image alt="Tamara" className="object-cover" fill src={tamaraImg} />
                            </div>
                            <p className="text-sm font-medium text-gray-700">{t("bridge.tamara")}</p>
                        </div>
                        <div className="text-center">
                            <div className="relative w-16 h-16 mb-10 mx-auto overflow-hidden">
                                <Image alt="Andrei" className="object-cover" fill src={andreiImg} />
                            </div>
                            <p className="text-sm font-medium text-gray-700">{t("bridge.andrei")}</p>
                        </div>
                    </div>

                    <Link
                        className="inline-flex items-center justify-center px-8 py-3 text-lg font-medium !text-white bg-primary-100 rounded-full hover:bg-primary-200 transition-colors"
                        href="/offer"
                    >
                        {t("bridge.cta")}
                    </Link>
                </div>
            </div>
        </section>
    );
}
